import type { SubscriptionsType } from '../types/subscriptions'

export const subscriptionsInitialValues: SubscriptionsType = {
  isLoading: false,
  error: null,
  items: null,
}
